export default __webpack_public_path__ + "static/media/avecImg.6ed1f215.jpg";